import service from "../../../assets/img/landings/invet/devices.png";
import solutions from "../../../assets/img/landings/invet/solutions.png";
import circles from "../../../assets/img/landings/circles_light.svg";
import onec from "../../../assets/img/landings/invet/icons/technology.png";
import gps from "../../../assets/img/landings/invet/icons/location.png";
import admin from "../../../assets/img/landings/invet/icons/admin.png";
import qr from "../../../assets/img/landings/invet/icons/qr-code.png";
import comments from "../../../assets/img/landings/invet/icons/blog.png";
import chat from "../../../assets/img/landings/invet/icons/chat.png";

export const data = {
  hero: {
    title: "Invet.ua",
    subtitle: "Logistics solution for vet drugs distribution",
    text: [
      "Invet.ua is a Ukrainian vet drugs distribution company operating for more than 10 years on the market. The company is an official and exclusive distributor of the leading global and local manufacturers of veterinary drugs. All the production is certified and is delivered throughout Ukraine.",
    ],
  },

  challenge: {
    title: "Challenge",
    text: [
      "With the company striving constantly to improve its efficiency and productivity, a request to create a logistics app for the employees emerged. Agilistry was asked to design the app from scratch: UI/UX design, mobile and web development, creation and maintenance of infrastructure, integration with third party services. However, the main challenge was to make the app handy for all the employees.",
    ],
  },

  solutions: {
    title: "Solutions",
    text: ["Developed a number of unique solutions:"],
    list: [
      {
        icon: onec,
        title: "Integration with 1C",
        text: "We integrated our app with the 1C service to get all the necessary information about the orders and display it",
      },
      {
        icon: gps,
        title: "Integration with GPS service",
        text: "An integration with GPS service allowed us to track the delivery of the orders on the map in real time",
      },
      {
        icon: admin,
        title: "Creation of admin panel",
        text: "To manage the use of the app we created admin panel where all orders, employees, vehicles are displayed and can be managed",
      },
      {
        icon: qr,
        title: "QR code scan",
        text: "We introduced the feature of scanning the QR code for the orders’ status update",
      },
      {
        icon: comments,
        title: "Text and voice comments",
        text: "So that all employees can be on the same page we allowed to add both text and voice comments to the orders",
      },
      {
        icon: chat,
        title: "Notifications and history",
        text: "Track every change in the orders with notifications and see the history of changes",
      },
    ],
    image: solutions,
    bgr: circles,
  },
  service: {
    image: service,
    text: "Would you like to see the full presentation of the solution?",
  },
};
